import {parsePropertyName} from './utils';
import {getRegisteredModels} from './registerModels';
import {ModelCollectionType, ModelType} from "./../types";

const models = getRegisteredModels();

export default class ModelFactory {
    constructor() {
        this.modelObject = null;
    }

    /**S
     * @param className
     * @param data|null
     * @returns {BaseModel}
     */
    createModel(className, data = null) {
        if (false === (className in models)) {
            throw `Model '${className}' is not registered`;    
        }
        
        const modelObject = new models[className]();
        const modelProperties = Object.getOwnPropertyNames(modelObject);

        modelProperties.map(property => {
            let dataPropertyValue = null;
            let modelPropertyValue = modelObject[property];

            if (data && data[parsePropertyName(property)] === undefined && data[property] !== undefined) {
                dataPropertyValue = data[property];
            }
            else if (data && data[parsePropertyName(property)] !== undefined && data[property] === undefined) {
                dataPropertyValue = data[parsePropertyName(property)];
            }
            else {
                let defaultPropertyValue = null;

                if (modelPropertyValue['default'] !== undefined) {
                    defaultPropertyValue = modelPropertyValue['default'];
                }

                modelObject[property] = modelObject[property] instanceof ModelCollectionType ? [] : defaultPropertyValue;

                return;
            }

            let newPropertyValue = dataPropertyValue;

            if (modelPropertyValue instanceof ModelCollectionType) {
                const modelName = modelPropertyValue.getModelClassName();

                newPropertyValue = this.createCollectionModels(modelName, dataPropertyValue)
            }
            else if (modelPropertyValue instanceof ModelType)  {
                const modelName = modelPropertyValue.getModelClassName();

                newPropertyValue = this.createModel(modelName, dataPropertyValue);
            }

            modelObject[property] = newPropertyValue;
        });

        this.setModel(modelObject);

        return this.getModel();
    }

    /**
     * @param className
     * @param data
     * @return {Array}
     */
    createCollectionModels(className, data) {
        const collection = [];

        if (data instanceof Array) {
            data.map(item => {
                const model = this.createModel(className, item);

                collection.push(model);
            });
        }

        return collection;
    }

    /**
     * @param {BaseModel} model
     * @return {ModelFactory}
     */
    setModel(model) {
        this.modelObject = model;

        return this;
    }
    
    /**
     * @returns {null|BaseModel}
     */
    getModel() {
        return this.modelObject;
    }
}